/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pnav_LabelInputs */

const en_pnav_label = /** @type {(inputs: Pnav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product sections`)
};

const de_pnav_label = /** @type {(inputs: Pnav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereiche des Produkts`)
};

/**
* | output |
* | --- |
* | "Product sections" |
*
* @param {Pnav_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pnav_label = /** @type {((inputs?: Pnav_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pnav_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pnav_label(inputs)
	return en_pnav_label(inputs)
});